module.exports = __webpack_public_path__ + "static/media/box-check.8b280517.svg";